export default __webpack_public_path__ + "static/media/logo.a6a80024.jpg";